import type {AjaxService} from 'core/data-services/ajax.service';
import type {FileDownloadService} from 'core/data-services/file-download.service';

export class WalletBarcodeCardDataService {
    public static serviceName = 'walletBarcodeCardDataService';

    public static readonly APPLE_ROUTE = 'wallet-barcode-card/apple';
    public static readonly GOOGLE_ROUTE = 'wallet-barcode-card/google';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService, private fileDownloadService: FileDownloadService) {
    }

    public async generateAppleWalletCard(): Promise<void> {
        return this.fileDownloadService
            .createRequest(WalletBarcodeCardDataService.APPLE_ROUTE)
            .download();
    }

    public async generateGoogleWalletCard(): Promise<Blob> {
        return this.ajaxService
            .createRequest(WalletBarcodeCardDataService.GOOGLE_ROUTE)
            .get();
    }
}